<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{$t('user.myInvestment')}}</div>
			<div class="money_box">
				<div class="item">
					<p class="money_num" v-html="'<span>'+utils_moneyMark()+'</span>'+data.on_money"></p>
					<p class="info">{{$t('user.uncollectedPrincipal')}}</p>
				</div>
				<div class="item">
					<p class="money_num" v-html="'<span>'+utils_moneyMark()+'</span>'+data.on_apr_money"></p>
					<p class="info">{{$t('user.uncollectedInterest')}}</p>
				</div>
				<div class="item">
					<p class="money_num" v-html="'<span>'+utils_moneyMark()+'</span>'+data.ok_apr_money"></p>
					<p class="info">{{$t('user.cumulativeIncome')}}</p>
				</div>
			</div>
		</div>
		<h3 class="notes_tit">{{$t('orders.record')}}</h3>
		<!-- 调试信息 -->
		<div style="padding: 10px; background: #f0f0f0; margin: 10px; font-size: 12px; border: 2px solid red;">
			<p><strong>🔍 调试信息:</strong></p>
			<p>empty状态: <span style="color: red; font-weight: bold;">{{ empty }}</span></p>
			<p>data对象: <span style="color: blue;">{{ data ? '存在' : '不存在' }}</span></p>
			<p>data.list: <span style="color: green;">{{ data && data.list ? '存在' : '不存在' }}</span></p>
			<p>data.list长度: <span style="color: orange; font-weight: bold;">{{ data && data.list ? data.list.length : '未定义' }}</span></p>
			<p>Vue版本测试: <span style="color: purple;">{{ $options.name || 'order' }}</span></p>
		</div>
		<van-empty :description="$t('orders.noOrders')" v-if="empty" />
		<div class="scrollBox">
			<div class="notes_box" v-if="!empty" v-for="i in data.list">
				<p class="timer">
					{{ i.time1 || i.time || '暂无时间' }}
					<span class="ing" v-if="i.status==0">{{$t('orders.unfinish')}}</span>
					<span class="finish" v-if="i.status==1">{{$t('orders.finish')}}</span>
				</p>
				<div class="item_div1">
					<p>
						{{i[lang] || i.project_name || i.zh_cn || '项目名称'}}
					</p>
				</div>
				<div class="item_div2">
					<div class="item_min">
						<p>{{utils_moneyMark()}}{{i.money2 || i.money || '0.00'}}</p>
						<p>{{$t('utils.investmentAmount')}}</p>
					</div>
					<div class="item_rate">
						<p>{{utils_moneyMark()}}{{i.money1 || i.interest || '0.00'}}</p>
						<p>{{$t('utils.income')}}</p>
					</div>
					<div class="item_day">
						<p>{{i.day || 1}}{{$t('utils.'+(i.unit || 'day'))}}</p>
						<p>{{$t('utils.cycle')}}</p>
					</div>
				</div>
        <div class="item_div1 download">
          <p style="text-align: center;color:#cc0000" @click="$router.push('/agreement/'+i.id)">
            {{$t('utils.agreement')}}
          </p>
        </div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty
	} from "vant";

	import Fetch from "../../utils/fetch";
	Vue.use(Empty);

	export default {
		name: "order",
		data() {
			return {
				lang: (this.$i18n.locale || "zh_CN").toLowerCase().replace('-', '_'),
				data: {
					list: [],
					on_money: '0.00',
					on_apr_money: '0.00',
					ok_apr_money: '0.00'
				},
				empty: false,
			};
		},
		created() {
			this.$parent.footer("user", false);
		},
		mounted() {
			this.start();
		},
		methods: {
			async start() {
				try {
					console.log('🚀 开始获取投资订单数据...');
					console.log('🌐 当前语言设置:', this.lang);
					console.log('🔑 localStorage token:', localStorage.getItem('token'));
					console.log('🗣️ localStorage lang:', localStorage.getItem('lang'));
					
					const result = await Fetch("/user/order");
					console.log('📡 投资订单API完整响应:', result);
					console.log('📡 result类型:', typeof result);
					console.log('📡 result.data类型:', typeof result.data);
					console.log('📡 result.data是否为数组:', Array.isArray(result.data));
					
					if (!result) {
						console.error('API响应为空');
						this.empty = true;
						return;
					}
					
					console.log('🔍 响应数据结构检查:');
					console.log('🔍 - result.code:', result.code);
					console.log('🔍 - result.info:', result.info);
					console.log('🔍 - result.data:', result.data);
					console.log('🔍 - result.data长度:', result.data ? result.data.length : '无');
					
					if (result && result.code === 1) {
						console.log('✅ API调用成功，开始处理数据...');
						
						let orderData;
						let rawList = [];
						
						// 检查返回的数据格式
						if (result.data && typeof result.data === 'object' && result.data.list) {
							// 标准格式：data是对象，包含list
							console.log('📋 使用标准数据格式');
							orderData = result.data;
							rawList = result.data.list;
						} else if (Array.isArray(result.data)) {
							// data是数组，需要转换为标准格式
							console.log('📋 data是数组，转换为标准格式');
							console.log('📋 原始数组长度:', result.data.length);
							console.log('📋 原始数组内容:', result.data);
							rawList = result.data;
							orderData = {
								list: rawList,
								on_money: "0.00",
								on_apr_money: "0.00", 
								ok_apr_money: "0.00"
							};
						} else if (result.info && Array.isArray(result.info)) {
							// 备用：数据在info字段
							console.log('📋 使用info字段数据');
							rawList = result.info;
							orderData = {
								list: rawList,
								on_money: "0.00",
								on_apr_money: "0.00", 
								ok_apr_money: "0.00"
							};
						} else {
							console.log('📋 使用默认空数据');
							orderData = {
								list: [],
								on_money: "0.00",
								on_apr_money: "0.00", 
								ok_apr_money: "0.00"
							};
						}
						
						// 数据格式转换和字段补全
						if (rawList && rawList.length > 0) {
							console.log('开始处理原始数据:', rawList);
							orderData.list = rawList.map(item => {
								// 根据实际API数据结构映射字段
								const processedItem = {
									...item,
									// 时间字段映射
									time: item.time1 || item.time || item.add_time || new Date().toISOString().slice(0, 19).replace('T', ' '),
									// 状态字段
									status: item.status !== undefined ? item.status : 0,
									// 投资金额 - 使用money2作为本金
									money: item.money2 || item.money || item.invest_money || '0.00',
									// 利息金额
									interest: item.money1 || '0.00',
									// 总收益
									total_return: item.pay1 || '0.00',
									// 计算利率 (利息/本金*100)
									rate: item.money2 && item.money1 ? ((parseFloat(item.money1) / parseFloat(item.money2)) * 100).toFixed(2) : '0.00',
									// 默认投资周期 - 如果没有具体数据，设为1天
									day: item.day || 1,
									unit: item.unit || 'day',
									// 项目名称处理
									project_name: item[this.lang] || item.project_name || item.zh_cn || item.title || '项目名称'
								};
								
								console.log('处理单项数据:', {
									原始: item,
									处理后: processedItem
								});
								
								return processedItem;
							});
							console.log('处理后的完整数据:', orderData.list);
						}
						
						// 强制更新Vue数据
						this.data = orderData;
						
						// 强制触发Vue响应式更新
						this.$nextTick(() => {
							console.log('🔄 Vue nextTick 后的状态:');
							console.log('🔄 this.data:', this.data);
							console.log('🔄 this.empty:', this.empty);
							console.log('🔄 DOM中的data.list长度:', this.data.list ? this.data.list.length : 'undefined');
						});
						
						console.log('📊 最终使用的投资订单数据:', this.data);
						console.log('📊 数据列表长度:', orderData.list ? orderData.list.length : 0);
						console.log('📊 Vue响应式检查 - this.data:', this.data);
						console.log('📊 Vue响应式检查 - this.empty:', this.empty);
						
						if (orderData && orderData.list && orderData.list.length > 0) {
							this.empty = false;
							console.log('✅ 找到投资记录:', orderData.list.length, '条');
							console.log('✅ 第一条记录:', orderData.list[0]);
							console.log('✅ empty状态:', this.empty);
							console.log('✅ data.list长度:', this.data.list.length);
						} else {
							this.empty = true;
							console.log('❌ 没有投资记录或数据为空');
							console.log('❌ orderData:', orderData);
							console.log('❌ orderData.list:', orderData ? orderData.list : 'orderData为空');
							console.log('❌ empty状态:', this.empty);
						}
					} else if (result && result.code === 0) {
						console.log('API返回业务提示:', result);
						this.empty = true;
					} else {
						console.error('获取投资订单失败:', result);
						this.empty = true;
					}
				} catch (error) {
					console.error('获取投资订单出错:', error);
					this.empty = true;
				}
			},
			wan(str) {
				var num = parseFloat(str);
				if (num > 99999) {
					return `${(num / 10000).toFixed(2)}万`;
				} else {
					return str || 0;
				}
			},
			lookHT(id) {
				this.$router.push("/contract/" + id);
			},
		},
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		height: 156px;
		background: #3775f4;
		background-size: 100% 100%;
		position: fixed;
		z-index: 15;
	}

	.money_box {
		margin-top: 29px;
		display: flex;
		padding: 0 6px;
		justify-content: space-around;
		color: #ffffff;

		.item {
			width: 33.33%;
			text-align: center;
			font-weight: bold;

			.money_num {
				font-size: 18px;
				line-height: 25px;
				white-space: normal;
				word-break: normal;
				text-align: center;
			}

			.info {
				font-size: 14px;
				line-height: 20px;
				margin-top: 5px;
			}
		}
	}

	.notes_tit {
		width: 100%;
		line-height: 44px;
		height: 44px;
		font-size: 14px;
		color: #000000;
		padding: 0 14px;
		position: fixed;
		top: 156px;
		left: 50%;
		transform: translateX(-50%);
		background: #FAFAFA;
		z-index: 2;
	}

	.notes_box {
		width: 100%;
		padding-bottom: 2px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
		border-radius: 6px;
		margin-bottom: 10px;

		.timer {
			padding: 12px 14px;
			font-size: 12px;
			color: rgba(0, 0, 0, .6);
			border-bottom: 1px solid #ececec;
			display: flex;
			justify-content: space-between;
			align-items: center;

			span {
				font-style: normal;
				padding: 5px;
				border-radius: 5px;
				color: #FFFFFF;
			}

			.ing {
				background: #3775f4;
			}

			.finish {
				font-style: normal;
				background: #07c160;
			}
		}

		.item_div1 {
			display: flex;
			justify-content: space-between;
			padding: 15px 10px;

			p:nth-child(1) {
				width: 100%;
				font-weight: bold;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;

			}
		}

		.item_div2 {
			display: flex;
			justify-content: space-between;
			text-align: center;
			margin-bottom: 10px;

			div {
				width: 33.33%;

				p {
					padding: 5px 0;
				}
			}

			.item_rate {
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;
					color: #FF0000;

				}

				p:nth-child(2) {
					color: #999;
				}
			}

			.item_day {
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;

				}

				p:nth-child(2) {
					color: #999;
				}
			}

			.item_min {
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;

				}

				p:nth-child(2) {
					color: #999;
				}
			}
		}
	}

	.scrollBox {
		margin-top: 200px;
		width: 96%;
		margin-left: 2%;
	}
</style>
